<template>
    <AddressEditable 
                     :address="normalizedAddress" 
                     :showPhone="showPhone" 
                     :showEmail="showEmail" 
                     :showCumulus="showCumulus" 
                     :allowZipCityEdit="allowZipCityEdit" 
                     :disableAddressPart="addressPartDisabled" 
                     :showFixAddressButton="showFixAddressButton" 
                     @change="updateAddress" 
                     @fixAddress="fixAddressTriggered" />
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true
            },
            showPhone: {
                type: Boolean,
                default: true
            },
            showEmail: {
                type: Boolean,
                default: true
            },
            showCumulus: {
                type: Boolean,
                default: true
            },
            allowZipCityEdit: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            normalizedAddress() {
                return {
                    salutation: this.address.salutation,
                    firstName: this.address.firstName,
                    lastName: this.address.lastName,
                    companyName: this.address.companyName,
                    street: this.address.street,
                    streetNumber: this.address.streetNumber,
                    addressLine2: this.address.addressLine2,
                    zipcode: this.address.zipcode,
                    city: this.address.city,
                    countryCode: this.address.countryCode,
                    phone: this.address.phone,
                    emailAddress: this.address.emailAddress,
                    cumulusNumber: this.address.cumulusNumber
                };
            },
            addressPartDisabled() {
                return this.address.isServerAddress;
            },
            showFixAddressButton() {
                return this.$listeners && this.$listeners.fixAddress && this.address.isServerAddress;
            }
        },
        methods: {
            updateAddress(normalizedAddress) {
                this.address.$update({
                    salutation: normalizedAddress.salutation,
                    firstName: normalizedAddress.firstName,
                    lastName: normalizedAddress.lastName,
                    companyName: normalizedAddress.companyName,
                    street: normalizedAddress.street,
                    streetNumber: normalizedAddress.streetNumber,
                    addressLine2: normalizedAddress.addressLine2,
                    zipcode: normalizedAddress.zipcode,
                    city: normalizedAddress.city,
                    countryCode: normalizedAddress.countryCode,
                    phone: normalizedAddress.phone,
                    emailAddress: normalizedAddress.emailAddress,
                    cumulusNumber: normalizedAddress.cumulusNumber
                });
            },
            fixAddressTriggered() {
                this.$emit('fixAddress');
            }
        }
    };
</script>